module.exports = __webpack_public_path__ + "static/media/Peter_Portrait_150.93d160e5.jpg";